import {
  buildTelegramOpenUrl,
  formatOpenInTelegramCopy,
  openZiaWellNavTelegram,
  type OpenInTelegramCopy,
} from './telegramRequiredAccess';

export type GpsUnsupportedAccessCopy = OpenInTelegramCopy;

const GPS_UNSUPPORTED_PATTERNS = [
  /gps\s+(is\s+)?not\s+supported/i,
  /gps.*unsupported/i,
  /unsupported.*gps/i,
  /geolocation\s+(is\s+)?not\s+supported/i,
  /geolocation.*unsupported/i,
  /unsupported.*geolocation/i,
  /geolocation api unavailable/i,
  /location sharing not supported/i,
  /gps works in the full telegram mini app/i,
];

const valueText = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (value instanceof Error) return value.message;
  if (!value || typeof value !== 'object') return '';
  const maybePayload = value as { reason?: unknown; message?: unknown; error?: unknown };
  return [maybePayload.reason, maybePayload.message, maybePayload.error]
    .filter((part): part is string => typeof part === 'string')
    .join(' ');
};

export function isGpsUnsupportedMessage(value: unknown): boolean {
  const text = valueText(value);
  if (!text) return false;
  if (/denied|permission|blocked by user/i.test(text)) return false;
  return GPS_UNSUPPORTED_PATTERNS.some((pattern) => pattern.test(text));
}

export function formatGpsUnsupportedAccess(_source?: unknown): GpsUnsupportedAccessCopy {
  return formatOpenInTelegramCopy({ feature: 'gps', reason: _source });
}

export function openGpsUnsupportedTelegram(url = buildTelegramOpenUrl({ feature: 'gps' })) {
  return openZiaWellNavTelegram(url);
}
